export default __webpack_public_path__ + "static/media/hp-plans-context-snippet-img.55f169e8.svg";